var idleTime = 0;
var t;

function cover() {

  var $this = $('#cover');
  var $coverImage         = $this.find(".bg-image"),
      $coverWrapper       = $this.find(".cover-wrapper"),
      $coverParticles     = $this.find("#particles-js"),
      $coverContent       = $this.find(".cover-content"),
      $coverOverlay       = $this.find(".cover-header").find(".logo.wfp"),
      $logoWFP            = $this.find(".cover-header").find(".logo.wfp"),
      $logoInnovation     = $this.find(".cover-header").find(".logo.innovation"),
      $coverMainTitle     = $this.find(".cover-content").find("h4"),
      $coverTopTitle      = $this.find(".cover-content").find(".toptitle"),
      $coverSubTitle      = $this.find(".cover-content").find(".subtitle"),
      $coverTitleSep      = $this.find(".cover-content").find(".title-sep"),
      $coverTitleLine     = $this.find(".cover-content").find(".title-line"),
      $coverScrollTo      = $this.find(".scroll-to");

  TweenMax.set($coverTitleSep, {css: {width: "0px"}});
  TweenMax.set($coverTitleLine, {css: {width: "0px", opacity: "0"}});

  var coverTL = new TimelineLite({paused: true});

  coverTL.to($coverWrapper, 0.2, {autoAlpha:1}, 0.2)
         // .from($coverImage, 3, {opacity: 0, scale: 1.1, ease: Power4.easeOut})
         .from($logoWFP, 1, {opacity: 0, yPercent: -20, ease: Power4.easeOut}, 1.7)
         .from($logoInnovation, 1, {opacity: 0, yPercent: -20, ease: Power4.easeOut}, 1.9)
         .from($coverScrollTo, 1, {opacity: 0, yPercent: -20, ease: Power4.easeOut}, 3)
         .staggerTo($coverTitleSep, 1, {css: {width: "30em"}, ease: Power4.easeOut}, 0.2, 0.6)
         .staggerTo($coverTitleLine, 1, {css: {opacity: 1}, ease: Power4.easeOut}, 0.2, 0.8)
         .staggerTo($coverTitleLine, 1, {css: {width: "30%"}, ease: Power4.easeOut}, 0.2, 0.4)
         .from($coverMainTitle, 1.5, {opacity: 0, x:-50, ease: Power4.easeOut}, 0.9)
         .from($coverTopTitle, 1.5, {opacity: 0, x:50, ease: Power4.easeOut}, 0.9)
         .from($coverSubTitle, 1.5, {opacity: 0, x:-50, ease: Power4.easeOut}, 0.9)
         .from($coverParticles, 3, {opacity: 0, ease: Power4.easeOut}, 2.2);

  var scene = new ScrollMagic.Scene({
    triggerElement: $this,
    triggerHook: 0,
    offset: 0
  })

  .on("enter", function (event) {
    coverTL.delay(1);
    coverTL.play().timeScale(1);
  })
  .on("leave", function (event) {})
  .addTo(controller);

  new ScrollMagic.Scene({triggerElement: $this, offset: 1, duration: "70%"})
        .setTween($coverParticles, {yPercent: 50, ease: Linear.easeNone})
        .addTo(controller);

  new ScrollMagic.Scene({triggerElement: $this, offset: 1, duration: "70%"})
        .setTween($coverContent, {opacity: 0, yPercent: 50, ease: Linear.easeNone})
        .addTo(controller);

  new ScrollMagic.Scene({triggerElement: $this, offset: 0, duration: "5%"})
        .setTween($coverScrollTo, {opacity: 0, ease: Linear.easeNone})
        .addTo(controller);

  new ScrollMagic.Scene({ triggerElement: $this, triggerHook: "onLeave", duration: "100%" })
        .on("leave", function (event) {
          stopParticles();
        })
        .on("enter", function (event) {
          if (window.pJSDom[0].pJS.particles.move.enable == false) {
            startParticles();
          }
        })
        .addTo(controller);

  window.onload = function () {
    resetTimer(stopParticles);
  };
  document.onmousemove = document.onkeypress = function (e) {
    resetTimer(stopParticles);
    if (window.pJSDom[0].pJS.particles.move.enable === false) {
      startParticles();
    }
  };
}

function stopParticles() {
  window.pJSDom[0].pJS.particles.move.enable = false;
}

function startParticles() {
  window.pJSDom[0].pJS.particles.move.enable = true;
  window.pJSDom[0].pJS.fn.particlesRefresh();
}

function resetTimer(callback) {
  clearTimeout(t);
  t = setTimeout(callback, 30000);
}